<template>
    <center-layout>
        <v-row
            no-gutters
            align="center"
            justify="center"
            :class="{ 'pb-4': $vuetify.breakpoint.mobile }"
        >
            <v-col>
                <h2>
                    New Entry
                </h2>
                <h3
                    :class="{
                        'pb-4': !$vuetify.breakpoint.mobile,
                        'pb-2': $vuetify.breakpoint.mobile
                    }"
                    v-text="pp_date"
                    @click="date_picker_modal = true"
                />
            </v-col>
            <v-col md="2" cols="12" class="text-right">
                <v-btn
                    icon
                    color="primary"
                    @click="upload_file"
                    :disabled="!content || !title"
                >
                    <v-icon>mdi-content-save-outline</v-icon>
                </v-btn>
                <router-link to="/entries">
                    <v-btn icon color="primary">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </router-link>
            </v-col>
        </v-row>
        <v-dialog
            ref="dialog"
            v-model="date_picker_modal"
            :return-value.sync="date_picker"
            persistent
            width="290px"
        >
            <v-date-picker v-model="date_picker" :max="today_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="date_picker_modal = false">
                    Cancel
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="$refs.dialog.save(date_picker)"
                >
                    Save
                </v-btn>
            </v-date-picker>
        </v-dialog>

        <v-text-field
            v-model="title"
            type="text"
            label="Entry Title"
            outlined
        />

        <v-textarea
            outlined
            label="Entry Content (Markdown)"
            v-model="content"
        />

        <vue-markdown :source="content" :emoji="false" class="diario--quote" />
    </center-layout>
</template>

<script>
import firebase from "firebase";
import { mapGetters } from "vuex";
import { format } from "date-fns";
import VueMarkdown from "vue-markdown";
import CenterLayout from "@/components/CenterLayout.vue";

export default {
    name: "NewEntry",
    components: {
        VueMarkdown,
        CenterLayout
    },
    data: function() {
        return {
            title: "",
            content: "",
            today_date: format(new Date(), "yyyy-MM-dd"),
            date_picker: format(new Date(), "yyyy-MM-dd"),
            date_picker_modal: false
        };
    },
    computed: {
        ...mapGetters({
            user: "user"
        }),
        pp_date: function() {
            let date_split = this.date_picker.split("-"),
                date_object = new Date(
                    Date.UTC(
                        Number(date_split[0]),
                        Number(date_split[1]) - 1,
                        Number(date_split[2]),
                        12,
                        0,
                        0
                    )
                );

            return date_object.toLocaleDateString(undefined, {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric"
            });
        }
    },
    methods: {
        generate_uuid: function() {
            var dt = new Date().getTime();
            var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                /[xy]/g,
                function(c) {
                    var r = (dt + Math.random() * 16) % 16 | 0;
                    dt = Math.floor(dt / 16);
                    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
                }
            );
            return uuid;
        },
        upload_file: function() {
            let database_reference = firebase
                    .database()
                    .ref()
                    .child(this.user.data.uid),
                storage_reference = firebase
                    .storage()
                    .ref()
                    .child(this.user.data.uid),
                filename = this.generate_uuid(),
                data_reference = database_reference.child(filename),
                file_reference = storage_reference.child(filename + ".md");

            let file = new Blob([this.content], { type: "text/plain" }),
                timestamp = new Date().toLocaleString();

            data_reference.set({
                title: this.title,
                filename: filename,
                date: this.date_picker,
                last_updated: timestamp
            });

            let upload_task = file_reference.put(file);
            upload_task.on(
                firebase.storage.TaskEvent.STATE_CHANGED,
                () => {},
                error => {
                    console.error(error);
                },
                () => {
                    this.$router.push({
                        name: "View",
                        params: { filename: filename }
                    });
                }
            );
        }
    }
};
</script>

<style scoped>
.diario--quote {
    border-left: 5px solid lightgray;
    padding-left: 15px;
}
</style>
